// Minimal space-aware route helpers for gem JS (vendored replacement for the
// host's `@/routes/helpers`). The host wraps the full js-routes bundle; the gem
// only needs the handful of routes consumed by its controllers, so the paths
// below are ported from the generated js-routes specs (conek-rails
// `app/frontend/routes/generated.js`) and reproduce them exactly:
//
//   taskPath              /s:g:b/tasks/:id
//   opportunityPath       /s:g:b/opportunities/:id
//   quotePath             /s:g:b/quotes/:id
//   previewPdfQuotePath   /s:g:b/quotes/:id/preview-pdf
//   contactPath           /s:g:b/contacts/:id
//   companyPath           /s:g:b/companies/:id
//   contactsPath          /s:g:b/contacts
//   calendarPath          /s:g:b/calendar
//
// Space context resolution mirrors the host's `getSpaceContext()`:
// `window.currentSpace` (set by the Rails layout) first, then the
// `/s:<group>:<branches>` URL prefix. Returns null outside a space so callers
// can degrade instead of building a broken href.

const URL_PATTERN = /^\/s:([^:]+):([^/]+)/
let cachedContext = null
let cachedPath = ""

function getSpaceContext() {
  if (typeof window === "undefined") return null

  if (window.currentSpace?.groupKey && window.currentSpace?.branchKeys) {
    return {
      groupKey: window.currentSpace.groupKey,
      branchKeys: window.currentSpace.branchKeys,
    }
  }

  const path = window.location.pathname
  if (path !== cachedPath) {
    cachedPath = path
    const match = path.match(URL_PATTERN)
    cachedContext = match
      ? { groupKey: match[1], branchKeys: match[2] }
      : null
  }
  return cachedContext
}

// Builds `/s:<group>:<branches><routePath>`; null when there is no space
// context (e.g. the notification row then renders as plain, non-clickable text).
function spacePath(routePath) {
  const context = getSpaceContext()
  if (!context) return null
  return `/s:${context.groupKey}:${context.branchKeys}${routePath}`
}

function idRoute(routePath) {
  return (id) => (id == null || id === "" ? null : spacePath(`${routePath}/${id}`))
}

function staticRoute(routePath) {
  return () => spacePath(routePath)
}

export const taskPath = idRoute("/tasks")
export const opportunityPath = idRoute("/opportunities")
export const quotePath = idRoute("/quotes")
export const previewPdfQuotePath = (id) =>
  id == null || id === "" ? null : spacePath(`/quotes/${id}/preview-pdf`)
export const contactPath = idRoute("/contacts")
export const companyPath = idRoute("/companies")
export const contactsPath = staticRoute("/contacts")
export const calendarPath = staticRoute("/calendar")
